import { yupResolver } from '@hookform/resolvers/yup'
import React, { useContext, useState, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import {
  Button,
  Form,
  FormField,
  Grid,
  GridColumn,
  GridRow,
  Loader,
} from 'semantic-ui-react'
import Swal from 'sweetalert2'
import * as yup from 'yup'
import { CustomerViewContext } from '../customer-info-view/customerView'
import {
  setSuddenDropAlarmsThreshold,
  getSuddenDropAlarmsThreshold,
} from '../../../../services/customer/index'
import styles from './customerSettings.module.css'

const formResolver = yup.object().shape({
  suddenDropAlarmsThreshold: yup
    .number()
    .required('sudden Drop Alarms Threshold is required')
    .typeError('Invalid sudden Drop Alarms Threshold'),
})
const successSwalContent = {
  title: 'Sudden drop alarms threshold is applied to the customer',
  confirmButtonColor: 'Green',
  icon: 'success',
}
const failSwalContent = {
  title: 'Error: Unable to set Sudden drop alarms threshold !',
  confirmButtonColor: 'Red',
  icon: 'error',
}
const CustomerSuddenDropSettings = () => {
  const [suddenDropAlarmsThresholdValue, setSuddenDropAlarmsThresholdValue] =
    useState(null)
  const [loading, setLoading] = useState(true)
  const {
    customerSettings: { tbCustomerId },
  } = useContext(CustomerViewContext)

  const { register, handleSubmit, errors, getValues } = useForm({
    resolver: yupResolver(formResolver),
  })
  const formHandler = async () => {
    Swal.showLoading()
    const body = {
      customerId: tbCustomerId,
      suddenDropAlarmsThreshold: getValues('suddenDropAlarmsThreshold'),
    }
    try {
      const response = await setSuddenDropAlarmsThreshold(body)
      if (response.success) {
        Swal.fire(successSwalContent)
      } else throw new Error()
    } catch (error) {
      Swal.fire(failSwalContent)
    }
  }
  useEffect(() => {
    const fetchThresholdValue = async () => {
      try {
        const result = await getSuddenDropAlarmsThreshold(tbCustomerId)
        setSuddenDropAlarmsThresholdValue(result.data)
      } catch (error) {
        console.error('Error fetching threshold value:', error)
      } finally {
        setLoading(false)
      }
    }

    if (tbCustomerId) fetchThresholdValue()
  }, [tbCustomerId])
  console.log('suddenDropAlarmsThresholdValue', suddenDropAlarmsThresholdValue)
  return (
    <Form
      style={{
        backgroundColor: 'rgb(216, 231, 234)',
        padding: 10,
        borderRadius: 9,
      }}
      id="suddenDropAlarmsThresholdForm"
      onSubmit={handleSubmit(formHandler)}
    >
      <h3 className={styles.formHeader}>Sudden Drop Alarms Threshold</h3>
      <FormField>
        <Grid columns={3}>
          <GridRow>
            <GridColumn>
              <FormField>
                <span>Sudden Drop Alarms Threshold:</span>
                {loading ? (
                  <Loader active inline="centered" />
                ) : (
                  <input
                    name="suddenDropAlarmsThreshold"
                    ref={register}
                    type="number"
                    defaultValue={suddenDropAlarmsThresholdValue || 4}
                    placeholder="Sudden Drop Alarms Threshold"
                  />
                )}
                <small style={{ color: 'red' }}>**</small>
                {errors.height && (
                  <p style={{ color: 'red' }}>
                    {errors.AlarmsThreshold.message}
                  </p>
                )}
              </FormField>
            </GridColumn>
          </GridRow>
        </Grid>
        <hr />
        <Grid>
          <Grid.Column textAlign="center">
            <Button type="submit" className={styles.Button} color="red">
              Submit
            </Button>
          </Grid.Column>
        </Grid>
      </FormField>
    </Form>
  )
}
export default CustomerSuddenDropSettings
